import { JsonPipe } from '@angular/common';
import { Component, input, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-error-modal',
  imports: [JsonPipe],
  templateUrl: './error-modal.html',
  styleUrl: './error-modal.scss',
})
export class ErrorModal {
  constructor(public activeModal: NgbActiveModal) { }
  public message = signal<string>("");
  public stacktrace = signal<any>(null);
}
